import React, { useState, useEffect } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Route, Routes } from 'react-router';
import { Layout } from './components/Layout';
import Home from './Pages/Home';
import Jobs from './Pages/Jobs';
import Agents from './Pages/Agents';
import Login from './Pages/Login';
import { useToken } from './components/items/UseToken';
import './custom.css';
import './robot.css';
import AdminManagement from './Pages/AdminManagement';
import Data from './Pages/Data';
import ResetPassword from './Pages/ResetPassword';
import WelcomeMessage from './Pages/WelcomeMessage';
import RequestPwdReset from './Pages/RequestPwdReset';
import AiChat from './AiChat/AiChat';
import Resources from './Pages/Resources';
import { useUser } from './Hooks/UserContext';
import AgentWizardStepper from './components/RobotsPageComponents/AgentWizardStepper';



function App() {
    const theme = createTheme({
        typography: {
            fontFamily: "'Poppins', sans-serif",
            h1: {
                fontWeight: 700,
                fontSize: "2.5rem",
                color: "#1E293B",
            },
            h2: {
                fontWeight: 600,
                fontSize: "2rem",
                color: "#1E293B",
            },
            button: {
                textTransform: "none",
                fontWeight: 600,
                borderRadius: "8px",
            },
        },
        palette: {
            neutral: {
                main: '#64748B',
                contrastText: '#fff',
            },
            primary: {
                main: "#7F56D9",
                contrastText: "#ffffff",
            },
            background: {
                default: "#F8FAFC",
                paper: "#ffffff",
            },
            text: {
                primary: "#1E293B",
                secondary: "#64748B",
            },
        },
        shape: {
            borderRadius: 6,
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        borderRadius: "6px",
                        textTransform: "none",
                        fontWeight: 600,
                        padding: "10px 18px",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    },
                },
            },
            MuiPaper: {
                defaultProps: {
                    tabIndex: undefined,
                },
            },
            MuiCard: {
                styleOverrides: {
                    root: {
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.05)",
                        borderRadius: "6px",
                    },
                },
            },
        },
    });


    const { setUser, user } = useUser();
    const { token, setToken } = useToken();

    const [isAuth, setIsAuth] = useState(false);

    const logOut = () => {
        fetch('api/logout', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(() => {
                localStorage.removeItem('token');
                setToken(null);
                setIsAuth(false);
            })
            .catch((error) => {
                console.error('Error during logout:', error);
            });
    };

    useEffect(() => {
        const authenticateUser = async () => {
            try {

                
                    const response = await fetch('api/authsession', {
                        method: 'POST',
                        credentials: 'include',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ token: "a" }),
                    });

                    if (response.status === 200) {
                        const data = await response.json();
                        setUser(data);
                        setIsAuth(true);
                    } else if (response.status === 401) {
                        localStorage.removeItem('token');
                        setToken(null);
                    }
                

              
            } catch (error) {
                console.error('Error during authentication:', error);
            }
        };

        authenticateUser();
    }, [setToken, setUser]);


    useEffect(() => {
        if (isAuth) {
            InitWidget();

        }
    }, [isAuth])

    const InitWidget = async () => {
        const widget = await fetch('api/deployagentwidget', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            }
        });
        if (widget.status === 200) {
            const widgetData = await widget.json();
            window.SophonaChatWidget.mount(widgetData.apiKey, window.location.origin.toString())
        } else {

        }
    }

    return (
        <div>
            <ThemeProvider theme={theme}>
                {!isAuth ? (
                    <Routes>
                        <Route path="*" element={<Login setToken={setToken} />} />
                        <Route exact path="/reset/:magicKey" element={<ResetPassword />} />
                        <Route exact path="/reset" element={<RequestPwdReset />} />
                        <Route exact path="/logincallback" element={<Login setToken={setToken} />} />
                        <Route exact path="/login" element={<Login setToken={setToken} />} />

                    </Routes>
                ) : isAuth && user?.firstname ? (
                    <Layout logOut={logOut}>
                        <Routes>
                            <Route exact path="/" element={<Home firstName={user.firstname} />} />
                            <Route exact path="/chat" element={<AiChat />} />
                            <Route exact path="/jobs" element={<Jobs initialTab="Jobs" />} />
                            <Route exact path="/agents" element={<Agents initialTab="Agents" />} />
                            <Route exact path="/agents/:agentGuid" element={<AgentWizardStepper />} />
                            <Route exact path="/resources" element={<Resources initialTab="Workers" />} />
                            <Route exact path="/management" element={<AdminManagement initialTab="Users" />} />
                            <Route exact path="/data" element={<Data initialTab="Queues" />} />
                            <Route path="/resources/processes" element={<Resources initialTab="Processes" />} />
                            <Route path="/resources/skills" element={<Resources initialTab="Skills" />} />
                            <Route path="/resources/workers" element={<Resources initialTab="Workers" />} />
                            <Route path="/resources/telephony" element={<Resources initialTab="Telephony" />} />
                            <Route path="/resources/apikeys" element={<Resources initialTab="Api Keys" />} />
                            <Route path="/jobs/scheduler" element={<Jobs initialTab="Scheduler" />} />
                            <Route path="/management/users" element={<AdminManagement initialTab="Users" />} />
                            <Route path="/data/queues" element={<Data initialTab="Queues" />} />
                            <Route path="/data/storage" element={<Data initialTab="Storage" />} />
                            <Route exact path="/logincallback" element={<Login setToken={setToken} />} />
                                </Routes>
                                
                                
                    </Layout>
                ) : null}
            </ThemeProvider>
        </div>
    );
}

export default App;
